import { Helpers } from '../../../../providers/helpers';
import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { SignupCommon } from './signup.common';
import { PageBaseFull } from '../../../../core/page-base.full';
import { UserData } from '../../../../providers/user-data'; 
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
import firebase from 'firebase';
import { AccountData } from '../../providers/account-data';
import { LoginCommon } from '../login/login.common';


@Component({
	selector: 'page-signup-full',
	templateUrl: 'signup.full.html'
})

export class SignupPageFull extends PageBaseFull{
	public signup: {displayName?:string, email?: string, password?: string} = {};
	public login: {email?: string, password?: string} = {};
	public singup = {
		email : "",
		displayName : "",
	};
	public submitted = false;
	public formMsg: any;
	public realtimeDb: any;
	public shoppingList: any;

	constructor(
    	public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: SignupCommon,
		public commonLogin: LoginCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
		public accountData: AccountData,
		public helpers: Helpers
    ) {	
		 super(settings, events, nav, userData);
		 console.log("Loading Sign Up Full");
		 this.realtimeDb = firebase.database();
    }

	ionViewDidEnter() {
		this.app.setTitle('Signup');
		
	}

	public onLogin(form){
		 this.commonLogin.onLogin(form, this.nav, this.login);
	}

	ngAfterViewInit() {
		let self = this;
		this.userData.getUser().subscribe(user => {
			//console.log(user);
			this.currentUser = user;
			console.log(this.currentUser);
			if(this.currentUser){
				self.accountData.getShoppingListData(this.currentUser.uid).subscribe(list => {
					console.log(list);
					self.shoppingList = list;
				});
			}
		});
	}

	public addToCart(itemKey){
		console.log(itemKey);
	}
	public cancel(){
		this.nav.setRoot(this.pageRef.get('home'));
	}

	public signupUser(form){
		let self = this;
		self.submitted = true;
		if(form.valid){
			self.userData.signup(self.signup.displayName, self.signup.email, self.signup.password).subscribe((res)=>{
				console.log('--------------res');
				console.log(res);
				if(res != null && (res.uid && res.uid !== '')){
					self.login = {
						email: self.signup.email,
						password: self.signup.password
					};
					self.signup.displayName = '';
					self.signup.email = '';
					self.signup.password = '';
					self.helpers.toast('Sign up account success!');
		 			self.commonLogin.onLogin(form, self.nav, self.login);
				}else{
					if(res.message){
						self.helpers.alert('Sign Up',res.message.message);
					}
				}
	    	});
		}
	}
	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/signup/signup.full.ts